<template>
	<div id="wjstate" class="wjstate">
		<div style="width: 100%; height: 100%;">
			<div class="leftNav">
				<div class="wjTypeChild" :style="{ height: height + 'px' }" style="overflow-y: hidden">
					
					<div style="text-align: center" class="wjTypeChildItemFont" :class="{
							wjTypeChildItem: index != 0,
							iconActive: index == selectIndex
						}" v-for="(item, index) in navList" :key="item.id">
						<div class="icon" @click="selectIcon(index)" v-show="item.show">
							<img :src="item.icon2" v-if="index == selectIndex" />
							<img :src="item.icon" v-else />
						</div>
						<span @click="selectIcon(index)" v-show="item.show">{{ item.label }}</span>
					</div>
				</div>
			</div>
			<div style="margin-left: 81px;padding: 20px;">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: '0',
				wid: 0,
				useInfo: {},
				height: 0,
				selectIndex: 0,
				navList: [{
						id: "0",
						label: this.$t('DataRecycling.QuestionBasedStatistics'),
						icon: require("../assets/tx/tongji.png"),
						icon2: require("../assets/tx/tongji1.png"),
						show:false
					},
					{
						id: "1",
						label: this.$t('DataRecycling.CrossAnalysis'),
						icon: require("../assets/tx/jiaochafenxi.png"),
						icon2: require("../assets/tx/jiaochafenxi1.png"),
						show:false
					},
					{
						id: "2",
						label: this.$t('DataRecycling.DataReport'),
						icon: require("../assets/tx/shujubaobiao.png"),
						icon2: require("../assets/tx/shujubaobiao1.png"),
						show:false
					},
					{
						id: "3",
						label: this.$t('DataRecycling.SourceAnalysis'),
						icon: require("../assets/tx/laiyuanfenxi.png"),
						icon2: require("../assets/tx/laiyuanfenxi1.png"),
						show:false
					},
					{
						id: "4",
						label: this.$t('DataRecycling.SubtitleStatisticsCopy'),
						icon: require("../assets/tx/tongji.png"),
						icon2: require("../assets/tx/tongji1.png"),
						show:false
					},
					// 20250709功能未完成暂不开放
					// {
					// 	id: "5",
					// 	label: "数据分析",
					// 	icon: require("../assets/tx/tongji.png"),
					// 	icon2: require("../assets/tx/tongji1.png"),
					// 	show:false
					// },
				]
			};
		},
		mounted() {
			console.log('this.navList :>> ', this.navList);
			this.type = this.$route.query.type || 0;
			this.activeIndex = this.type + '';
			this.wid = sessionStorage.getItem('wid');
			this.useInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
			window.onresize = () => {
				var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
				this.height = winHeight - 108;
				this.rightheight = winHeight - 60;
			};

			let hrefText = window.location.href;
			let hrefList = hrefText.split('/')
			let href = hrefList.pop(); // 删除数组最后一个并返回删除的元素  
			if (href == 'itemStatistics') {
				this.selectIndex = 0
			} else if (href == 'crossAnalysis') {
				this.selectIndex = 1
			} else if (href == 'dataReport') {
				this.selectIndex = 2
			} else if (href == 'sourceAnalysis') {
				this.selectIndex = 3
			} else if (href == 'itemStatisticsCopy') {
				this.selectIndex = 4
			}else if (href == 'dataAnalysis') {
				this.selectIndex =5
			}
		},
		created() {
			this.accessPermission();
		},
		methods: {
			accessPermission() {
				let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
				// console.log(userInfo.permissionList);
				let arr = userInfo.permissionList;
				let permissionList = {};
				arr.forEach((item, index) => {
					permissionList['admin' + item] = item;
				});
				console.log(permissionList);
				// this.permissionList = permissionList;
				this.navList.forEach(item=>{
					
					// 分题统计
					if(permissionList.admin1012){
						if(item.id == 0){
							item.show = true
						}
					}else{
						if(item.id == 0){
							item.show = false
						}
					}
					// 交叉分析
					if(permissionList.admin1013){
						if(item.id == 1){
							item.show = true
						}
					}else{
						if(item.id == 1){
							item.show = false
						}
					}
					// 数据报表
					if(permissionList.admin1014){
						if(item.id ==2){
							item.show = true
						}
					}else{
						if(item.id == 2){
							item.show = false
						}
					}
					// 来源分析
					if(permissionList.admin1015){
						if(item.id == 3){
							item.show = true
						}
					}else{
						if(item.id == 3){
							item.show = false
						}
					}
					
					// 分题统计复制
					if(permissionList.admin1016){
						if(item.id == 4){
							item.show = true
						}
					}else{
						if(item.id == 4){
							item.show = false
						}
					}
					
					// 数据分析
					if(permissionList.admin1017){
						if(item.id == 5){
							item.show = true
						}
					}else{
						if(item.id == 5){
							item.show = false
						}
					}
				})
				
			},
			
			handleCommand(command) {
				console.log(command);
				if (command == 0) {
					this.$router.push({
						path: '/personal'
					});
				} else if (command == 2) {
					window.localStorage.clear();
					this.$router.push({
						path: '/login'
					});
				} else if (command == 3) {
					this.$router.push({
						path: '/contant'
					});
				}
			},
			backwj() {
				this.$router.push('/my');
			},
			selectIcon(index) {
				this.selectIndex = index;
				if (index == 0) {
					this.$router.push('/itemStatistics')
				} else if (index == 1) {
					this.$router.push('/crossAnalysis')
				} else if (index == 2) {
					this.$router.push('/dataReport')
				} else if (index == 3) {
					this.$router.push('/sourceAnalysis')
				} else if (index == 4) {
					this.$router.push('/itemStatisticsCopy')
				}else if (index == 5) {
					this.$router.push('/dataAnalysis')
				}
			},
		}
	};
</script>

<style scoped lang="scss">
	.activebox div i {
		color: #0080ff !important;
	}

	.activebox p {
		color: #0080ff;
	}

	.wjstate {
		width: 100%;
		/* height: 100%; */
		display: flex;
	}

	.leftNav {
		width: 80px;
		height: 100%;
		background: #ffffff;
		position: fixed;
		border-right: 1px solid #ccc;
	}

	.leftNav div li {
		list-style: none;
	}

	.textStyle {
		font-size: 14px;
		color: #333;
	}

	.boxbox {
		margin: 0 auto;
		width: 60px;
		margin-top: 18px;
	}

	.iconStyleBox {
		width: 50px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.rightNav {
		width: 100%;
		height: auto;
	}

	.wjTypeChild {
		width: 80px;
		background-color: #fff;
		padding-top: 15px;
		padding-bottom: 30px;
		float: left;
		display: inline;

		.wjTypeChildItemFont {
			font-size: 12px;
			cursor: pointer;

			.icon {
				margin: 0px auto;
				width: 50px;
				height: 50px;
				border-radius: 5px;

				img {
					margin-top: 12px;
				}
			}
		}

		.wjTypeChildItem {
			text-align: center;
			margin-top: 40px;
		}

		.iconActive {
			color: #0080ff;
		}

		.iconActive>.icon {
			background-color: #0080ff;
		}
	}
</style>
